import { TranslateService } from '@ngx-translate/core';

export class TranslateInstance {
  static translateService: TranslateService;
}
